<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 5A11 11 0 115 16 11 11 0 0116 5m0-2a13 13 0 1013 13A13 13 0 0016 3z"/><path d="M13 11.5l7.51 4.5L13 20.49v-9m0-2a2 2 0 00-2 2v9a2 2 0 002 2 2 2 0 001-.28l7.51-4.5a2 2 0 000-3.43L14 9.78a2 2 0 00-1-.28z"/></svg>